import { plural, t } from '@lingui/core/macro';

interface Props {
  upcomingCount: number;
  completedCount: number;
  upcomingTotal?: string;
  completedTotal?: string;
}

export const FleetCalendarStats = ({ upcomingCount, completedCount, upcomingTotal, completedTotal }: Props) => {
  const upcomingLabel = t`Upcoming bookings`;
  const completedLabel = t`Completed bookings`;

  return (
    <div className='grid grid-cols-2 gap-3'>
      <Stat label={t`${upcomingLabel} this month`} value={upcomingCount} sub={upcomingTotal} />
      <Stat label={t`${completedLabel} this month`} value={completedCount} sub={completedTotal} />
    </div>
  );
};

interface StatProps {
  label: string;
  value: number;
  sub?: string;
}

const Stat = ({ label, value, sub }: StatProps) => (
  <div className='flex flex-col gap-1 rounded-xl bg-white p-4'>
    <div className='text-[11px] font-semibold tracking-wider text-muted-foreground uppercase'>{label}</div>
    <div className='flex items-baseline gap-2'>
      <span className='text-2xl font-semibold tabular-nums'>{value}</span>
      <span className='text-sm text-muted-foreground'>{plural(value, { one: 'booking', other: 'bookings' })}</span>
    </div>
    {sub && <div className='text-xs text-muted-foreground tabular-nums'>{sub}</div>}
  </div>
);
